<div class="container-fluid animated fadeIn">
	<div class="row flex-column align-items-center my-5">
		<!-- STEPS TITLE -->
		<div class="col-12 mb-4">
			<div class="wiz-title text-center">
				{{ 'supplier-upload.pageTitle' | translate }}
			</div>
		</div>
		<!--CONTENT -->
		<div class="col-12 col-xl-8">
			<eif-custom-stepper
				[steps]="steps"
				[currentStep]="currentStep">
			</eif-custom-stepper>

			<div class="simple-card top-line">
				<div class="row justify-content-center px-3 py-3 px-md-5 py-md-5">
					<div class="col-auto w-xs-100">
						<div class="text-uppercase text-secondary mt-2 mb-3">
							{{ 'supplier-upload-step2.SupplierUploadInfoText' | translate }}
						</div>
						<eif-file-upload
							[multiple]="false"
							[accept]="'.xls,.xlsx,.csv'"
							[uploadLabel]="'supplier-upload-step2.SupplierUploadLabel' | translate"
							[uploadSubtext]="'supplier-upload-step2.SupplierUploadSubtext' | translate"
							[buttonText]="'supplier-upload-step2.SupplierUploadBrowseFile' | translate"
							(fileSelected)="onFileChange($event)"
							(filesChange)="handleFilesChange($event)"
							#fileUpload>
						</eif-file-upload>
					</div>
				</div>
			</div>
			<div class="d-flex align-items-center justify-content-between">
				<div class="d-flex flex-grow-1">
					<a
						role="button"
						class="is-color-primary"
						(click)="openInstructionsModal()">
						<i class="fa-solid fa-info-circle me-2"></i>
						<span>{{ 'supplier-upload.howToUpload' | translate }}</span>
					</a>
				</div>
				<!-- BUTTONS AREA -->
				<div class="d-flex align-items-center justify-content-xs-center justify-content-end p-4">
					<div>
						<eif-custom-button
							[text]="'button.back' | translate"
							[color]="'neutral'"
							[class]="'mb-0'"
							(action)="redirectToDocumentsStep1()">
						</eif-custom-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
